@if (brightnessEnabled) {
<button
  matIconButton
  cdkOverlayOrigin
  #triggerBrightness="cdkOverlayOrigin"
  matTooltipPosition="right"
  [matTooltip]="!this.displayPanel ? 'Brightness / Contrast' : null"
  class="mat-icon-toggle-button"
  type="button"
  [class.selected]="displayPanel"
  (click)="togglePanelDisplay()">
  <mat-icon svgIcon="brightness_contrast"></mat-icon>
</button>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="triggerBrightness"
  [cdkConnectedOverlayOpen]="displayPanel"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top'
    }
  ]">
  <div class="inverse-surface overlay">
    <div class="d-flex flex-row align-items-center">
      <div class="d-flex flex-column">
        <div class="d-flex flex-row align-items-center panel-tool">
          <mat-icon svgIcon="brightness" class="tool-icon"></mat-icon>
          <div (click)="decreaseBrightness()">
            <button type="button" matIconButton>
              <span><mat-icon>remove</mat-icon></span>
            </button>
          </div>
          <!-- TODO: The 'tickInterval' property no longer exists -->
          <mat-slider matTooltip="Brightness" matTooltipPosition="below" showTickMarks discrete min="{{ MIN_VALUE }}" max="{{ MAX_VALUE }}" step="{{ STEP_VALUE }}" #ngSlider>
            <input
              matSliderThumb
              value="{{ currentBrightness }}"
              (change)="changeBrightness({ source: brigthtnessSliderThumb, parent: ngSlider, value: brigthtnessSliderThumb.value })"
              #brigthtnessSliderThumb="matSliderThumb" />
          </mat-slider>
          <div (click)="increaseBrightness()">
            <button type="button" matIconButton>
              <span><mat-icon>add</mat-icon></span>
            </button>
          </div>
        </div>
        <div class="d-flex flex-row align-items-center panel-tool">
          <mat-icon svgIcon="contrast" class="tool-icon"></mat-icon>
          <div (click)="decreaseContrast()">
            <button type="button" matIconButton>
              <span><mat-icon>remove</mat-icon></span>
            </button>
          </div>
          <!-- TODO: The 'tickInterval' property no longer exists -->
          <mat-slider matTooltip="Contrast" matTooltipPosition="below" showTickMarks discrete min="{{ MIN_VALUE }}" max="{{ MAX_VALUE }}" step="{{ STEP_VALUE }}" #ngSlider>
            <input
              matSliderThumb
              value="{{ currentContrast }}"
              (change)="changeContrast({ source: contrastSliderThumb, parent: ngSlider, value: contrastSliderThumb.value })"
              #contrastSliderThumb="matSliderThumb" />
          </mat-slider>
          <div (click)="increaseContrast()">
            <button type="button" matIconButton>
              <span class="add-remove-icon"><mat-icon>add</mat-icon></span>
            </button>
          </div>
        </div>
      </div>
      <button type="button" color="on-primary" matButton (click)="reset()">Reset</button>
    </div>
  </div>
</ng-template>

}
